import { Controller } from "stimulus"

export default class extends Controller {
  static values = { open: Boolean }

  connect() {
    if (this.openValue) {
      $(this.element).modal("show")
    }
  }
}
